import NewTaskBaseForm from './NewTaskBaseForm'
import { useGetCoursesQuery } from '../courses/coursesApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useParams } from 'react-router-dom'
import { useGetTaskBasesQuery } from './taskBasesApiSlice'

const NewTaskBase = () => {
    useTitle('geshtop-Exercise: New Task Base')


    const { courses } = useGetCoursesQuery("coursesList", {
        selectFromResult: ({ data }) => ({
            courses: data?.ids.map(id => data?.entities[id])
        }),
    })
    if (!courses?.length) return <PulseLoader color={"#FFF"} />

    const content = <NewTaskBaseForm courses={courses}  />

    return content
}
export default NewTaskBase